const environment = import.meta.env.MODE;
export const isProdMode = environment === "production";
